<template>
    <div>
        <ul
            class="flex w-full gap-8 text-sm font-medium border-b border-slate-200"
        >
            <li class="relative" v-for="tab in tabs" :key="tab">
                <a
                    class="flex items-center gap-2 pt-2 pb-4 hover:text-slate-800 focus:outline-slate-300 rounded"
                    :class="{
                        'border-b-2 border-orange-600 text-slate-800': tab.name === activeTab, 'text-slate-600': tab.name !== activeTab
                    }"
                    @click.prevent="store.setTab(tab.name)"
                    role="button"
                    tabindex="0"
                >
                    {{ tab.label }}
                    <Icon
                        v-if="tab.icon"
                        :icon="tab.icon"
                        class="-mb-[1px] relative"
                    />
                </a>
            </li>
        </ul>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useCalendarStore } from '@/store/calendar';
import Icon from '@/components/ui/icon/icon.vue';

const store = useCalendarStore();
const { activeTab } = storeToRefs(store);

defineProps({
    tabs: {
        type: Array,
        required: true,
    },
});
</script>
